'use client';

import useFormFillPage from '@/hooks/use-form-fill-page';
import { useQuery } from '@tanstack/react-query';

import { useMemo } from 'react';

import { QUERY_KEY_INITIALS } from '@/shared/constants/query-key-initials';
import { checkFormEditAccess } from '@/shared/services/forms/forms';
import { ICheckFormEditAccessPayload } from '@/shared/services/forms/forms.types';

export function useFormEditAccess() {
	const { updatedFormFillDetails, updatedUserDetails } = useFormFillPage();

	const formId = updatedFormFillDetails?.id;
	const isUserLoggedIn = !!updatedUserDetails;

	const queryKey = useMemo(() => [QUERY_KEY_INITIALS.CHECK_FORM_EDIT_ACCESS, formId], [formId]);

	const { data, isLoading } = useQuery({
		queryKey,
		queryFn: ({ queryKey }) => {
			const [, formId] = queryKey;

			if (!formId) {
				return { hasAccess: false };
			}

			const payload: ICheckFormEditAccessPayload = {
				form_id: String(formId),
			};

			return checkFormEditAccess(payload);
		},
		enabled: isUserLoggedIn && !!formId,
		retry: false,
	});

	const hasAccess = data?.hasAccess ?? false;

	return {
		hasAccess,
		isLoading,
	};
}
